import moment from "moment";
// import all supported locale to use the localized moment
import "moment/locale/fr";
import "moment/locale/de";
import "moment/locale/he";
import "moment/locale/it";
import "moment/locale/es";
import "moment/locale/ja";
import "moment/locale/ko";
import "moment/locale/pt";
import "moment/locale/ru";
import "moment/locale/vi";
import "moment/locale/en-gb";

moment.locale("en"); // setup default locale

export default moment;
